import React, { useState, useEffect, useRef } from 'react';
import { Card, Button, theme } from 'antd';
import { CheckCircleFilled, ArrowDownOutlined, ReloadOutlined } from '@ant-design/icons';

export const StepByStepWidget = ({ config }) => {
    const { steps = [] } = config;
    const [currentStep, setCurrentStep] = useState(0);
    const bottomRef = useRef(null);

    const isLastStep = currentStep >= steps.length - 1;
    const hasSteps = steps.length > 0;

    const nextStep = () => {
        if (!isLastStep) {
            setCurrentStep(prev => prev + 1);
        }
    };

    const reset = () => setCurrentStep(0);

    useEffect(() => {
        if (bottomRef.current) {
            bottomRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [currentStep]);

    if (!hasSteps) {
        return <div className="ch-card padding--m text-muted text-center">No steps provided.</div>;
    }

    return (
        <div className="ch-step-widget width-100">
            <Card
                className="ch-card shadow-sm"
                title={<span className="ch-text-bold">Solution Walkthrough</span>}
            >
                <div className="flexColumn mediumGap">
                    {steps.map((step, index) => {
                        if (index > currentStep) return null;
                        const isCompleted = index < currentStep;
                        const isLatest = index === currentStep;

                        return (
                            <div key={index} className={`ch-step-item animate-fade-in ${isCompleted ? 'ch-step-completed' : ''}`}>
                                <div className="flexAlignCentre gap-medium margin-b--xs">
                                    <div className={`ch-step-badge ${isCompleted ? 'ch-step-badge-done' : ''}`}>
                                        {isCompleted ? <CheckCircleFilled /> : index + 1}
                                    </div>
                                    <span className={`ch-text-med-font ${isLatest ? 'ch-text-bold' : ''}`}>
                                        {step.title || `Step ${index + 1}`}
                                    </span>
                                </div>
                                <div className="ch-step-body">
                                    <div className={`ch-step-content ${step.highlight ? 'ch-highlight-bg' : ''}`}>
                                        {step.content}
                                    </div>
                                    {step.note && (
                                        <div className="ch-alert-warning margin-t--s ch-text-small border-radius-component padding--s flexAlignCentre gap-small">
                                            <span>💡</span>
                                            <span>{step.note}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}

                    <div ref={bottomRef} />

                    <div className="flexAlignCentre flexJustifyEnd margin-t--m border-t--s padding-t--m">
                        {!isLastStep ? (
                            <Button type="primary" onClick={nextStep} icon={<ArrowDownOutlined />} size="large" className="ch-btn-animate">
                                Next Step
                            </Button>
                        ) : (
                            <div className="flexAlignCentre gap-medium fade-in">
                                <span className="ch-text-bold ch-text-success flexAlignCentre gap-small">
                                  <CheckCircleFilled /> Complete
                                </span>
                                <Button onClick={reset} icon={<ReloadOutlined />}>Replay</Button>
                            </div>
                        )}
                    </div>
                </div>
            </Card>
        </div>
    );
};